<template>
  <div
    :key="plan?.id"
    :class="['w-[300px] flex flex-col items-center justify-center rounded-2xl px-4 py-6 relative']"
    :style="
      !selected && plan?.best
        ? {
            backgroundColor: '#F8FEFA',
            border: '1px solid #2A8176',
          }
        : { boxShadow, border: '1px solid transparent' }
    "
  >
    <div
      v-if="!selected && plan?.best"
      :class="[
        'absolute won-green-background-color rounded-full h-6',
        'flex items-center justify-center text-white text-xs font-semibold',
      ]"
      style="width: 136px; top: -12px"
    >
      Best Value
    </div>
    
    <div class="h-full w-full">
        <div class="text-base text-center font-medium uppercase won-color-subtitle-gray">
          {{ plan?.title }}
        </div>
    
        <div style="color: #505d68">
            <!-- plans-->
            <p v-if="showModalToUsers && plan?.type === 'premium' && getUser().generations > 10 "
               class="mb-4 text-3xl font-medium text-center"><span
                class="text-[#C2C4C6] line-through mr-1">$19.99</span> <span class="">$14.99</span></p>
            <p v-if="plan?.type === 'free' "
               class="mb-4 text-3xl font-medium text-center"><span class="">FREE</span></p>
            <p v-else-if="plan?.type === 'premium' && getUser()?.discounted != null "
               class="mb-4 text-3xl font-medium text-center"><span
                class="text-[#C2C4C6] line-through mr-1">{{ formatPrice(getUser().original_amount, getUser().currency) }}  </span> <span
                class="">{{ formatPrice(getUser().next_billing_amount, getUser().currency) }} </span></p>
            <p v-else-if="!isSubscribe && discountCoupon?.discounted_amount"
               class="mb-4 text-3xl font-medium text-center"><span
                class="text-[#C2C4C6] line-through mr-1">{{ formatPrice(plan?.prices?.unit_amount, plan?.prices?.currency) }}</span> <span
                class="">{{ formatPrice(discountCoupon?.discounted_amount.toFixed(2), plan?.prices?.currency) }}</span></p>
            <p v-else class="mb-4 text-3xl font-medium text-center"> {{ formatPrice(plan?.prices?.unit_amount, plan?.prices?.currency) }}</p>
            
            <!--  Discount-->
            <div class="text-center" v-if="!discountCoupon">{{ plan?.description }}</div>
            <div class="text-center" v-else>{{ discountCoupon?.metadata?.description }}</div>
        </div>
        
    <div
      v-if="selected"
      :class="[
        'w-full h-9 flex items-center justify-center rounded',
        'won-light-green-background-color mt-5',
      ]"
    >
      <checked class="mr-2.5" />
      <div class="text-sm won-color-green font-semibold">Selected</div>
    </div>

    <div
      v-else-if="!selected && !isSubscribe && plan.type !== 'free'"
      :class="[
        'w-full rounded h-9 flex items-center justify-center',
        'text-sm font-semibold mt-5 cursor-pointer',
        !selected && plan?.best
          ? 'text-white won-green-background-color'
          : 'won-color-green',
      ]"
      style="border: 1px solid #2a8176"
      @click="() => $emit('option:select', plan)"
    >
      Upgrade Plan
    </div>

    <div
         v-else-if="isSubscribe && userPlan?.stripe_price !== plan.default_price && plan.type !== 'free'"
          :class="[
        'w-full rounded h-9 flex items-center justify-center',
        'text-sm font-semibold mt-5 cursor-pointer',
        !selected && plan?.best
          ? 'text-white won-green-background-color'
          : 'won-color-green',
      ]"
          style="border: 1px solid #2a8176"
          @click="() => $emit('option:select', plan)"
      >
          Upgrade Plan
      </div>
        
    <div
      v-if="!isSubscribe && !showModalToUsers && plan.type === 'free' && !allowExitToFreePlan"
      :class="[
        'w-full rounded h-9 flex items-center justify-center',
        'text-sm font-semibold mt-5 cursor-pointer won-color-green won-light-green-background-color',
      ]"
    >
      Current Plan
    </div>

    <div
        v-if="!isSubscribe && plan.type === 'free' && allowExitToFreePlan"
        @click="premiumNudgeStore.hideModal"
        :class="[
            'w-full rounded h-9 flex items-center justify-center border-won-green border',
            'text-sm font-semibold mt-5 cursor-pointer text-won-green',
        ]"
    >
        Upgrade later
    </div>
        
    <div
      v-if="showModalToUsers && plan.type === 'free'"
      :class="[
        'w-full rounded h-9 flex items-center won-color-green won-light-green-background-color justify-center',
        'text-sm font-semibold mt-5 cursor-pointer ',
      ]" 
      @click="() => $emit('select:free-plan')"
    >
      Select Plan
    </div>

     <div
        v-if="isSubscribe && !isOnGracePeriod && userPlan?.stripe_price === plan.default_price"
          :class="[
        'w-full rounded h-9 flex items-center justify-center',
        'text-sm font-semibold mt-5 cursor-pointer won-color-green won-light-green-background-color',
        ]"
      >
          Next Billing Date: {{getUser().next_billing_date}}
      </div>

    <div
        v-if="isSubscribe && isOnGracePeriod && userPlan?.stripe_price === plan.default_price"
          :class="[
        'w-full rounded h-9 flex items-center justify-center',
        'text-sm font-semibold mt-5 cursor-pointer bg-won-red-light text-won-red',
        ]"
      >
          Expiration Date: {{getUser().next_billing_date}}
      </div>

      <div
          v-if="isSubscribe && !isOnGracePeriod && userPlan?.stripe_price === plan.default_price"
          :class="[
          'w-full rounded h-9 flex items-center justify-center',
          'text-sm font-semibold mt-5 cursor-pointer bg-won-red-light text-won-red border-solid border-won-red',
          ]"
          id="typeform"
          @click="popup.toggle()"
      >
         Cancel Plan
      </div>
      
       <won-button @click="$emit('plan:resume', plan.default_price)" v-if="isSubscribe &&  isOnGracePeriod && userPlan?.stripe_price === plan.default_price" class="w-full mt-4">
            <svg v-if="isSubmittingResumeSubscription" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                 xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                        stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Resume
        </won-button>
  

      <div
          class="w-full h-px won-gray-background-color"
          style="margin-top: 14px; margin-bottom: 7px"
      />

      <div v-if="plan.benefits" class="flex flex-col p-2 w-full items-start justify-center">
          <subscription-feature
              v-for="feature of plan.benefits.features"
              :key="plan.id"
              :feature="feature"
          />
      </div>
  <div>

  </div>
    </div>
      <SuccessCancelSubscriptionModal
          :active-until="activeUntil"
          :showModal="showSuccessCancelSubscriptionModal"
          :closeModal="hideSuccessCancelSubscriptionModal"
      />
  </div>
</template>

<script>
import { ref } from "vue";
import { storeToRefs } from 'pinia'
import { useSubscriptionPlanStore } from "../../../store/subscription.store";
import { useNotifications } from "../../../store/notifications.store";
import { useFeatureUsageStore } from "../../../store/feature-usage.store";
import { usePremiumNudgeStore } from "../../../store/nudge-premium.store";
import { setAuthState } from '../../../composables/auth'

// Components
import WonCoin from '../../../icons/won-coin.vue'
import Checked from '../../../icons/checked.vue'
import SubscriptionFeature from "./subscription-feature";
import WonButton from "../../won-button.vue";
import SuccessCancelSubscriptionModal from "./success-cancel-subscription-modal.vue";

import moment from "moment";

import { createPopup } from '@typeform/embed'
import '@typeform/embed/build/css/popup.css'

import { cancel } from "../../../api/subscription";

export default {
  components: {SuccessCancelSubscriptionModal, WonButton, SubscriptionFeature, WonCoin, Checked },
    props: {
        plan: {
          type: Object,
          default: () => ({}),
        },
        selected: {
          type: Boolean,
          default: false,
        },
        showModalToUsers: {
          type: Boolean,
          default: false,
        },
        isSubmittingResumeSubscription: {
          type: Boolean,
          default: false, 
        },
        allowExitToFreePlan: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['option:select', 'plan:cancel', 'select:free-plan', 'plan:resume'],
    setup(props, { emit }) {
      const submitting = ref(false);
      const subscriptionStore = useSubscriptionPlanStore()
      const premiumNudgeStore = usePremiumNudgeStore();
      const { getUser } = setAuthState()
      const { userPlan, setIsSubscribe, isSubscribe, isOnGracePeriod, discountCoupon } = storeToRefs(subscriptionStore)
      const popup = ref(null)
      const activeUntil = ref(null)
      const showSuccessCancelSubscriptionModal = ref(false)

        popup.value = createPopup(`https://form.typeform.com/to/qgkhLnng`, {
            mode: 'popup',
            size: '80',
            hidden: {
                user_id: getUser().id,
                email: getUser().email,
            },
            onSubmit: () => {
                console.log('Form submitted!')
                cancelSubscription()
               
            },
        })

        const cancelSubscription = async () => {
            const notificationStore = useNotifications()
            submitting.value = true

            try {

                const cancelSubscription = await cancel()

                if (cancelSubscription?.data?.success) {
                    submitting.value = false
                    setAuthState().setUser(cancelSubscription.data?.user)
                    useSubscriptionPlanStore().setUserPlan(cancelSubscription?.data?.user?.current_plan)
                    useSubscriptionPlanStore().setOnGracePeriod(cancelSubscription?.data?.user?.on_grace_period)
                    useFeatureUsageStore().setFeatureUsage(cancelSubscription?.data?.user?.feature_usage)

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "subscription_cancelled",
                    });

                    activeUntil.value = moment(cancelSubscription?.data?.user?.current_plan.ends_at).format("MM-DD-YYYY");

                    popup.value.close();
                    showSuccessCancelSubscriptionModal.value = true
                }

                if (cancelSubscription?.data?.error) {
                    submitting.value = false
                    notificationStore.notify(cancelSubscription?.data?.error ?? 'Something went wrong', 'error')
                }

            } catch(error){
                notificationStore.notify(error.response.data.message ?? 'Something went wrong', 'error')
            }
        }

        const hideSuccessCancelSubscriptionModal = (resume = false) => {
            showSuccessCancelSubscriptionModal.value = false
            if(resume){
                emit('plan:resume', props.plan.default_price)
            }
        }
        const currencyMap = {
            inr: { symbol: '₹', abbreviation: 'INR' },
            usd: { symbol: '$', abbreviation: 'USD' },
            cad: { symbol: '$', abbreviation: 'CAD' },
            aed: { symbol: 'د.إ', abbreviation: 'AED' }
        };

        const formatPrice = (amount, currency) => {
            if (!amount) return '';
            const formattedAmount = (amount / 100).toFixed(2); // Assuming amount is in minor units (e.g., cents)
            const currencyData = currencyMap[currency.toLowerCase()] || {};

            return currencyData.symbol
                ? `${currencyData.symbol}${formattedAmount} ${currencyData.abbreviation}`
                : formattedAmount;
        };

        return {
            userPlan,
            isSubscribe,
            setIsSubscribe,
            isOnGracePeriod,
            submitting,
            getUser,
            discountCoupon,
            formatPrice,
            popup,
            hideSuccessCancelSubscriptionModal,
            activeUntil,
            premiumNudgeStore,
            showSuccessCancelSubscriptionModal
        }
  },

  data: () => ({
    boxShadow: '0px 0px 12px rgba(0, 0, 0, 0.1)',
  }),
}
</script>
